export const MODAL_SPINNER_ID = `structure-from-name-modal`;
export const MIN_QUERY_LENGTH = 3;
export const COUNT_SHOW_SUBSTANCES = 3;
